import { Product } from '../types';

interface ProductCardProps {
  product: Product;
  onEdit: () => void;
  onDelete: () => void;
}

function shortenUrl(url: string, maxLength = 70): string {
  const cleanUrl = url.split('?')[0];
  if (cleanUrl.length > maxLength) {
    return cleanUrl.substring(0, maxLength - 1) + '…';
  }
  return cleanUrl;
}

export function ProductCard({ product, onEdit, onDelete }: ProductCardProps) {
  const priceDisplay = (product.current_price !== null && product.current_price !== undefined)
    ? `${product.current_price.toFixed(2)} ${product.currency || 'EUR'}`
    : 'Pas encore de prix';

  return (
    <div className="bg-gray-800 border border-gray-700 rounded-xl p-4 hover:border-gray-600 transition-colors">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 mb-1">
            <h3 className="text-lg font-semibold text-white truncate">{product.custom_name}</h3>
            <span className="text-xl font-bold text-green-400 whitespace-nowrap">{priceDisplay}</span>
          </div>
          <p className="text-sm text-gray-500 truncate">{shortenUrl(product.amazon_url)}</p>
          {product.last_checked && (
            <p className="text-xs text-gray-600 mt-1">
              Dernière vérification : {new Date(product.last_checked).toLocaleString('fr-FR')}
            </p>
          )}
        </div>
        <div className="flex items-center gap-2 flex-wrap md:flex-nowrap">
          <button
            onClick={onEdit}
            className="px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-500 text-white font-medium rounded-lg transition-colors flex items-center gap-1"
            title="Modifier"
          >
            ✏️ Modifier
          </button>
          <button
            onClick={onDelete}
            className="px-3 py-1.5 text-sm bg-red-600 hover:bg-red-500 text-white font-medium rounded-lg transition-colors flex items-center gap-1"
            title="Supprimer"
          >
            🗑️ Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}